import { CodeBlock } from '@/types';

export const queries: CodeBlock[] = [
  {
    label: `Simple`,
    query: `query {
  shows {
    title
    description
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
      }
    ]
  }
}`,
  },
  {
    label: `Complex`,
    query: `query {
  shows(stage: PUBLISHED) {
    title
    description
    poster {
      url
    }
    episodes {
      title
      actors {
        name
        biography
      }
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "poster": {
          "url": "https://media.graphcms.com/WOa8NtHKT3WnIlshxrGT"
        },
        "episodes": [
          {
            "title": "Pilot",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Diversity Day",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Health Care",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "The Alliance",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Basketball",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          },
          {
            "title": "Hot Girl",
            "actors": [
              {
                "name": "Steve Carell",
                "biography": "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
              },
              {
                "name": "Rainn Wilson",
                "biography": "Rainn Wilson lives in Los Angeles with his wife, fiction writer Holiday Reinhorn (Big Cats), and his son, Walter McKenzie Wilson who was born in 2004. He grew up in Seattle, Washington but graduated from New Trier H.S. in Winnetka, Illinois."
              },
              {
                "name": "John Krasinski",
                "biography": "Tall, handsome American film and television star John Krasinski is known for his role as sardonic nice guy Jim Halpert on NBC's popular TV series, The Office (2005), for which he won a 2007 and 2008 Screen Actors Guild Award for outstanding performance by an ensemble in a comedy series."
              },
              {
                "name": "Jenna Fischer",
                "biography": "Emmy-nominated actress Jenna Fischer, known for playing the character of receptionist Pam Beesley in The Office (2005), was born Regina Marie Fischer on March 7, 1974 in Fort Wayne, Indiana. She is the daughter of Anne (Miller), a teacher, and James E. Fischer, a plastic engineer."
              },
              {
                "name": "Melora Hardin",
                "biography": "Melora Hardin was born on June 29, 1967 in Houston, Texas, USA as Melora Diane Hardin. She is an actress, known for 17 Again (2009), Hannah Montana: The Movie (2009) and The Office (2005). She has been married to Gildart Jackson since June 4, 1997. They have two children."
              }
            ]
          }
        ]
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "poster": {
          "url": "https://media.graphcms.com/xgfwIg0hQeyNAYjOmfsX"
        },
        "episodes": []
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "poster": {
          "url": "https://media.graphcms.com/fwItiNHoTba8BUfaNEsu"
        },
        "episodes": [
          {
            "title": "From Pole to Pole",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Mountains",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Fresh Water",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Caves",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Deserts",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Great Plains",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Jungles",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Shallow Seas",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Seasonal Forests",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          },
          {
            "title": "Ocean Deep",
            "actors": [
              {
                "name": "David Attenborough",
                "biography": "Born 8 May 1926, the younger brother of actor Lord Richard Attenborough. He never expressed a wish to act and, instead, studied Natural Sciences at Cambridge University, graduating in 1947, the year he began his two years National Service in the Royal Navy."
              },
              {
                "name": "Sigourney Weaver",
                "biography": "Sigourney Weaver was born Susan Alexandra Weaver, on October 8, 1949, in Leroy Hospital in New York City. Her father, TV producer Sylvester L. Weaver Jr., originally wanted to name her Flavia, because of his passion for Roman history (he had already named her elder brother Trajan)."
              }
            ]
          }
        ]
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "poster": {
          "url": "https://media.graphcms.com/2HiMRsBQPm9FbqyFG3or"
        },
        "episodes": []
      }
    ]
  }
}`,
  },
  {
    label: `Filtering`,
    query: `query {
  shows(where: {
    title_contains: "Planet"
    episodes_some: {
      length_gt: 30
    }
  }) {
    title
    description
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      }
    ]
  }
}`,
  },
  {
    label: `Sorting`,
    query: `query {
  shows(orderBy: createdAt_ASC) {
    title
    description
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
      }
    ]
  }
}`,
  },
  {
    label: `Pagination`,
    query: `query {
  shows(first: 2 skip: 1) {
    title
    description
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
      }
    ]
  }
}`,
  },
  {
    label: `Localization`,
    query: `query {
  shows(locales: [en, de]) {
    title
    description
    localizations(includeCurrent: true) {
      description
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "localizations": [
          {
            "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium."
          },
          {
            "description": "The Office ist eine amerikanische Mockumentary-Sitcom-Fernsehserie, die den Arbeitsalltag von Büroangestellten in der Filiale der fiktiven Dunder Mifflin Paper Company in Scranton, Pennsylvania, darstellt."
          }
        ]
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "localizations": [
          {
            "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends."
          }
        ]
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "localizations": [
          {
            "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition."
          },
          {
            "description": "Planet Earth ist eine britische Fernsehserie aus dem Jahr 2006, die von der BBC Natural History Unit produziert wurde. Fünf Jahre später war es die teuerste Naturdokumentationsserie, die jemals von der BBC in Auftrag gegeben wurde, und auch die erste, die in High Definition gedreht wurde."
          }
        ]
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "localizations": [
          {
            "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement."
          }
        ]
      }
    ]
  }
}`,
  },
  {
    label: `Transforming Assets`,
    query: `query {
  shows {
    title
    description
    poster {
      url(transformation: {image: {resize: {width: 200}}})
    }
  }
}`,
    response: `{
  "data": {
    "shows": [
      {
        "title": "The Office",
        "description": "A mockumentary on a group of typical office workers, where the workday consists of ego clashes, inappropriate behavior, and tedium.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/WOa8NtHKT3WnIlshxrGT"
        }
      },
      {
        "title": "Seinfeld",
        "description": "The continuing misadventures of neurotic New York City stand-up comedian Jerry Seinfeld and his equally neurotic New York City friends.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/xgfwIg0hQeyNAYjOmfsX"
        }
      },
      {
        "title": "Planet Earth",
        "description": "Emmy Award-winning, 11 episodes, five years in the making, the most expensive nature documentary series ever commissioned by the BBC, and the first to be filmed in high definition.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/fwItiNHoTba8BUfaNEsu"
        }
      },
      {
        "title": "The Wire",
        "description": "The Baltimore drug scene, as seen through the eyes of drug dealers and law enforcement.",
        "poster": {
          "url": "https://media.graphcms.com/resize=width:200/2HiMRsBQPm9FbqyFG3or"
        }
      }
    ]
  }
}`,
  },
];

export const mutations: CodeBlock[] = [
  {
    label: `Create`,
    query: `mutation {
  createActor(data: {
    name: "Steve Carel",
    biography: "Steve Carell, one of America's most versatile comics, was born Steven John Carell on August 16, 1962, in Concord, Massachusetts. He is the son of Harriet Theresa (Koch), a psychiatric nurse, and Edwin A. Carell, an electrical engineer. His mother was of Polish descent and his father of Italian and German ancestry."
  }) {
    id
  }
}`,
    response: `{
  "data": {
    "createActor": {
      "id": "cki51mbnk1n0e0b57qbt3oy8w"
    },
  }
}`,
  },
  {
    label: `Update`,
    query: `mutation {
  updateActor(
    where: {
      name: "Steve Carel"
    },
    data: {
      name: "Steve Carell"
    }
  ) {
    id
    name
  }
}`,
    response: `{
  "data": {
    "updateActor": {
      "id": "cki51mbnk1n0e0b57qbt3oy8w",
      "name": "Steve Carell"
    },
  }
}`,
  },
  {
    label: `Delete`,
    query: `mutation {
  deleteActor(
    where: {
      name: "Jenna Fischer"
    }
  ) {
    id
  }
}`,
    response: `{
  "data": {
    "deleteActor": {
      "id": "cki51p5i81mch0a63cqm8nd3r"
    },
  }
}`,
  },
  {
    label: `Publish`,
    query: `mutation {
  publishActor(
    where: {
      name: "David Attenborough"
    },
    to: PUBLISHED
  ) {
    id
  }
}`,
    response: `{
  "data": {
    "publishActor": {
      "id": "cki52b1bc1pby0a01623n2yk7"
    },
  }
}`,
  },
];

export const sdk: CodeBlock[] = [
  {
    label: `Quickstart`,
    code: {
      language: `js`,
      content: `const { newMigration, FieldType } = require("@graphcms/management");

const migration = newMigration({ endpoint: "...", authToken: "..." });

const author = migration.createModel({
  apiId: "Author",
  apiIdPlural: "Authors",
  displayName: "Author",
});

author.addSimpleField({
  apiId: "firstName",
  displayName: "First Name",
  type: FieldType.String,
});

author.addSimpleField({
  apiId: "lastName",
  displayName: "Last Name",
  type: FieldType.String,
});

migration.run();`,
    },
  },
  {
    label: `Running a Migration`,
    code: {
      language: `js`,
      content: `const foreground = true;

const result = migration.run(foreground);

if (result.errors) {
  console.log(result.errors);
} else {
  console.log(result.name);
}`,
    },
  },
  {
    label: `Create a Model`,
    code: {
      language: `js`,
      content: `const { newMigration } = require("@graphcms/management");

const migration = newMigration({ endpoint: "...", authToken: "..." });

const modelName = migration.createModel({
  apiId: "...",
  apiIdPlural: "...",
  displayName: "...",
  description: "...",
});`,
    },
  },
  {
    label: `Create a Field`,
    code: {
      language: `js`,
      content: `const { FieldType } = require("@graphcms/management");

model.addSimpleField({
  apiId: '...',
  displayName: '...',
  type: FieldType.String,
});`,
    },
  },
  {
    label: `Create a Union Field`,
    code: {
      language: `js`,
      content: `const { RelationType } = require("@graphcms/management");

model.addUnionField({
  apiId,
  displayName,
  relationType: RelationType.OneToOne,
  models, // list of related models

  // optional but can be specified to customize the details.
  reverseField: {
    apiId,
    displayName,
  },
});`,
    },
  },
  {
    label: `Create a Remote Field`,
    code: {
      language: `js`,
      content: `model.addRemoteField({
  apiId,
  displayName,
  remoteConfig: {
    method, // one of GET (default), POST or PUT.
    payloadFieldApiIds, // Array<String> of field API IDs to send as part of request payload
    returnType, // previously declared remote type definition
    url, // url to fetch the remote data from
  },
});`,
    },
  },
];
